import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

const DETAILS_WRAPPER_WIDTH = '300px'

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: ${Spacing.S16};
  width: ${DETAILS_WRAPPER_WIDTH};
  padding-left: ${Spacing.S16};
  border-left: 1px solid ${Color.Grey150};
`
